export function pipe(...fns) {
  return (...initial) => fns.reduce((args, fn) => [fn.apply(null, args)], initial);
}
